import React from 'react';
import Sidebar from '../../../components/common/SidebarSettingMenu/Sidebar';
import { Outlet } from 'react-router-dom';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { Box } from '@mui/material';

type SettingPageProps = {
	children?: React.ReactNode;
};

const settingTheme = createTheme({
  typography: {
    fontFamily: 'inherit',
  },
});

const SettingPage : React.FC<SettingPageProps> = () => {
  return (
    <ThemeProvider theme={settingTheme}>
      <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, minHeight: '100vh', p: { xs: '20px 16px', md: '40px' } }}>
        <Box component="aside" sx={{ width: { xs: '100%', md: '250px' }, borderRight: { xs: 'none', md: '1px solid #eee' }, borderBottom: { xs: '1px solid #eee', md: 'none' }, flexShrink: 0 }}>
          <Sidebar />
        </Box>
        <Box component="main" sx={{ flex: 1, pl: { xs: 0, md: '60px' }, pt: { xs: 2, md: 0 }, minWidth: 0 }}>
          <Outlet />
        </Box>
      </Box>
    </ThemeProvider>
  );
};

export default SettingPage;